<template>
    <v-layout column align-center>
        <h2>One Time Codes Setup</h2>
        <br />

        <v-data-table
          :headers="headers"
          :items="codes"
          class="elevation-1"
        >
          <template
            slot="items"
            slot-scope="props"
          >
            <tr @click="viewLocation(props.item)" style="cursor: pointer">
              <td class="body-2 text-xs-left">{{ props.item.code }}</td>
              <td class="body-2 text-xs-left">{{ props.item.name }}</td>
              <td class="text-xs-right">
                        <v-icon
                          small
                          @click.stop="deleteCode(props.item)"
                        >
                          delete
                        </v-icon>
                      </td>
            </tr>
          </template>
        </v-data-table>
        <hr />
        <v-layout row>
            <v-text-field
               label="Code"
               placeholder="Put code here"
               v-model="newCode"
             ></v-text-field>
             <v-text-field
                label="Name"
                placeholder="Put name here"
                v-model="newName"
              ></v-text-field>
              <v-btn @click="addCode">Add Code</v-btn>
        </v-layout>


    </v-layout>
</template>

<script>
  // import utils from '@/utils.js'
  import firebase from 'firebase/app'


  export default {
      data () {
        return {
            // timeRange: [0, 1440],
            newCode: null,
            newName: null,
            codes: [],
            headers: [
              // {text: 'Category', value: 'category', align: 'left'},
              {text: 'Code', value: 'code', align: 'left'},
              {text: 'Name', value: 'name', align: 'left'},
              {text: 'Actions', value: '', align: 'right'}
            ]
        }
      },
      watch: {
          updateNum: function() {
              // This is simply to force a redraw

          }
      },
      mounted: function () {
          this.getCodes()
      },
      computed: {

      },
      methods: {
          getCodes: async function () {
              // Load the codes from the DB
              // Check if we're an admin
              let codesRef = firebase.database().ref('one_time_codes')

              try {
                  let snap = await codesRef.once("value")
                  if (snap.exists()) {
                      // Go through and add all the codes to the list.
                      var newCodes = [];
                      snap.forEach(function(childSnapshot) {
                          var key = childSnapshot.key;
                          var name = childSnapshot.val();
                          // console.log(childSnapshot);
                          newCodes.push({"code":key, "name":name});
                      });
                      this.codes = newCodes;
                  } else {
                      this.error("Error: Could not load the codes!");
                  }
              } catch (e) {
                console.error("Caught an exception:"+e);
              }

          },
          addCode: async function() {
              // Save the new code
              let codesRef = firebase.database().ref('one_time_codes').child(this.newCode);
              await codesRef.set(this.newName);
              this.getCodes();
          },
          deleteCode:async function (code) {
              //console.log("Delete code: "+code);

              // Save the new code
              let codesRef = firebase.database().ref('one_time_codes').child(code.code);
              await codesRef.remove();

              // Reload
              this.getCodes();
          }
      }

  }
</script>

<style>

</style>
